module.exports = __webpack_public_path__ + "static/media/54.a996c79a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/poinkos/54.jpg
// module id = 587
// module chunks = 0